// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/66ecc2e9622bf54fd116.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"38f96ff1715e85ad9449","161":"b436db468b666585cc8f","162":"cc9a836de8712fd715b9"}[chunkId] + ".chunk.js";
};